export const APPROVE_PROJECT = 'APPROVE_PROJECT'
export const REJECT_PROJECT = 'REJECT_PROJECT'
export const REJECT_ACTIVE_PROJECT = 'REJECT_ACTIVE_PROJECT'
export const REJECT_DELIVERY = 'REJECT_DELIVERY'
export const APPROVE_DELIVERY = 'APPROVE_DELIVERY'
export const REJECT_DELIVERY_BRAND = 'REJECT_DELIVERY_BRAND'
export const APPROVE_DELIVERY_BRAND = 'APPROVE_DELIVERY_BRAND'
export const APPROVE_AND_FEATURE_DARE = 'APPROVE_AND_FEATURE_DARE'
